import React from 'react';

import { Link } from 'react-router-dom';

const HEALTH_YOURSELF_URL = process.env.REACT_APP_SECURE_APP_URL;

interface SmartLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const SmartLink: React.FC<SmartLinkProps> = ({
  to,
  children,
  className,
  style,
}) => {
  const isInnerUrl =
    (HEALTH_YOURSELF_URL && to.includes(HEALTH_YOURSELF_URL)) ||
    to.startsWith('/');

  return isInnerUrl ? (
    <Link to={to} className={className} style={style}>
      {children}
    </Link>
  ) : (
    <a
      href={to}
      className={className}
      target='_blank'
      rel='noopener noreferrer'
      style={style}
    >
      {children}
    </a>
  );
};

export default SmartLink;
